import React from 'react';
import './index.css'; // Import the custom styles

const whitepaperUrl =
  'https://incrypt-public-assets-global.s3.ap-southeast-2.amazonaws.com/documents/whitepaper.pdf';

const mono = 'ui-monospace, "SF Mono", Menlo, Consolas, monospace';

export const WhitePaperDoc: React.FC = () => {
  return (
    <div style={{ height: '100dvh', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          padding: '14px clamp(14px, 3vw, 26px)',
          borderBottom: '1px solid rgba(140,170,190,0.14)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
          flexWrap: 'wrap'
        }}
      >
        <div>
          <div
            style={{
              font: `800 10px ${mono}`,
              letterSpacing: '0.4em',
              textTransform: 'uppercase',
              color: '#ffcf40'
            }}
          >
            White Paper
          </div>
          <div
            style={{
              marginTop: 5,
              fontWeight: 900,
              fontSize: 20,
              letterSpacing: '-0.01em',
              color: '#e8f4fb'
            }}
          >
            The INCRYPT{' '}
            <span style={{ color: '#38e8ff' }}>white paper</span>
          </div>
        </div>
        <a
          href={whitepaperUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-track="whitepaper.open_pdf"
          style={{
            font: `800 12px ${mono}`,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            color: '#38e8ff',
            textDecoration: 'none',
            border: '1px solid rgba(56,232,255,0.4)',
            background: 'rgba(56,232,255,0.1)',
            borderRadius: 10,
            padding: '9px 15px'
          }}
        >
          Open PDF ↗
        </a>
      </div>
      <iframe
        src={whitepaperUrl}
        title="Incrypt Whitepaper"
        style={{
          width: '100%',
          flex: 1,
          border: 0
        }}
      />
    </div>
  );
};
